import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import withStyles, { ThemeProvider } from 'react-jss'
import queryString from 'query-string'

import { REDIRECTION_KEYS } from 'constants/embeddableItems.constants'

import { deepObjectPropNamesToSnakeCase } from 'utils/nameStyle.utils'
import { getSellerLink } from 'utils/helpers.utils'

import { EloSlider } from '@elo-kit/components'
import embeddableItemStyles from '../embeddableItemStyles'
import Badge from './Badge'

@inject('productsStore')
@observer
class Slider extends Component {
  render() {
    const {
      productLink,
      productLink: {
        seller,
        embedPrefs: { redirection, arrowColor },
      },
      classes,
      productsStore,
      isPreview,
    } = this.props
    const slideItems = productsStore.list.map((product) => {
      const redirectToPaymentPage = redirection === REDIRECTION_KEYS.paymentPage
      const baseUrl = getSellerLink(seller, redirectToPaymentPage ? '/payment' : '')
      return (
        <Badge
          productLink={productLink}
          product={product}
          key={product.id}
          url={`${baseUrl}?${queryString.stringify(deepObjectPropNamesToSnakeCase(productLink.params))}`}
          forSlider
        />
      )
    })
    return (
      <div className={classes.marginFix}>
        <div id='elopageSliderContainer' className={classes.slider}>
          <EloSlider
            id={productLink.token}
            slideItems={slideItems}
            updateDisabled={isPreview}
            style={{
              activeElementScale: 1.1,
              modifier: 1.5,
              arrowsColor: arrowColor,
            }}
          />
        </div>
      </div>
    )
  }
}

const StyledSlider = withStyles(embeddableItemStyles)(Slider)

const SliderContainer = (props) => (
  <ThemeProvider theme={props.productLink.embedPrefs}>
    <StyledSlider {...props} />
  </ThemeProvider>
)

export default SliderContainer
